// eslint-disable-next-line
import { request, requestEdm, requestStu } from './index';
import qs from 'query-string';
import { ChannelResponse, EmailVerificationCodeRequest, EmailVerificationCodeResponse } from './interface/pinyin-class';
import {
  EventTrackingReq,
  EventTrackingRes,
  ClueTrackInfoReq,
  ClueTrackInfoRes,
  GenerateSchemeRes,
  GenerateSchemeReq,
  StudentInfoRes,
  ITrackInfoReq,
  ITrackInfoReS,
  User,
  GetTimeZoneListRes,
  AdvisorInfo,
} from './interface/common';
import { ICreateOrFindLeadReq, ICreateOrFindLeadRes } from '@/api/interface/commonGatWay';

export const getCountry = () => {
  return request.post('/public/reserve/country/info');
};

export const getCountryNew = (data?: { showChinaDomestic?: boolean }) => {
  return request.post(
    qs.stringifyUrl({
      url: '/public/reserve/country/v2',
      query: {
        ...data,
      },
    }),
  );
};

/**
 * 判断是否是新新线索
 *
 * @param {{ email: string; subject: string }} data 邮箱与科目
 * @return {*}
 */
export const getUser = (data: { email: string; subject: string; studentCode: string }) => {
  return request.post<User, User>('/public/track/isNew', data);
};

// 获取时间 public/timestamp
export const getTimestamp = () => {
  return request.get<number, number>(`/public/timestamp`);
};

export const createLead = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/lead/create', data, {
      signature: true,
      timestamp: res,
    });
  });
};

export const createLeadNoRemind = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/lead/create', data, {
      signature: true,
      timestamp: res,
      skipErrorHandler: true,
    });
  });
};

// 约课进线接口修改

export const createLeadNoRemindNew = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/lead/create', data, {
      signature: true,
      timestamp: res,
      skipErrorHandler: true,
    });
  });
};

// 发送邮箱验证码
export const sendEmailVerificationCode = (data: EmailVerificationCodeRequest) => {
  return request.put('/public/email/send', data);
};

// 验证邮箱验证码
export const verifyEmailVerificationCode = (data: EmailVerificationCodeRequest) => {
  return request.post<EmailVerificationCodeResponse, EmailVerificationCodeResponse>('/public/email/verification', data);
};

export const getJsonNode = (id: string) => {
  return requestEdm.get<ChannelResponse, ChannelResponse>(`/public/ref/json_node/${id}`);
};

export const sendPosterReportEvent = (data: any) => {
  return requestEdm.post<ChannelResponse, ChannelResponse>(`/public/poster/center/scanqr/data`, data);
};

// 查询当前手机号 或者邮箱 是否是新老线索
export const getClueTrackInfo = (params: ClueTrackInfoReq) => {
  return request.post<ClueTrackInfoRes, ClueTrackInfoRes>(`/public/poster/center/track/info/data`, {
    ...params,
  });
};

// 获取小程序scheme码

export const getGenerateScheme = (params: GenerateSchemeReq) => {
  return request.get<GenerateSchemeRes, GenerateSchemeRes>(`/public/api/wechat/share/generateScheme`, { params });
};

// 通过学号获取学生剩余课时，所有天数

export const getStudentDayAndClass = (params: any) => {
  return request.post<StudentInfoRes, StudentInfoRes>(`/public/lead/student_learning/${params}`);
};

// 通过参数查询信息 如学号等
export const getTrackInfo = (params: ITrackInfoReq) => {
  return request.post<ITrackInfoReS, ITrackInfoReS>(`/public/track/info`, {
    ...params,
  });
};

// 生成市场活动记录
export const repeatActive = (params: { trackId: string; leadId: string }) => {
  return requestEdm.post('/public/lead/repeatActive/', params);
};

// 获取使用通用版本还是专属版本
export const getMultipleVersionType = () => {
  return request.get<boolean, boolean>(`/public/reserve/showChinaDomestic`);
};

// 移动端用时区接口
export const getTimeZoneListMobile = () => {
  return requestEdm.get<GetTimeZoneListRes, GetTimeZoneListRes>(`/public/ref/timezones/ddl/group`);
};

// 获取学习规划师信息
export const getAcademicAdvisorInfo = (data?: { scanType?: string; studentCode?: string; subject?: string | null }) => {
  return request
    .post<{ content: AdvisorInfo }, { content: AdvisorInfo }>('/public/show/planner_info', {
      subject: null,
      ...data,
    })
    .then((res) => res?.content);
};

// 新 进线接口
// 缩短留资接口
// 前端多判断多查询问题：
// 接口：/public/rs/lead/create

// 流程：
// 1.接口无data?.studentCode ，再次调用约课获取学生学号 /public/poster/center/track/info/data/ （参数mobile subject）
// 返回最新的学号
// 2.已付费用户不在约课 /public/student/paid
// 接口返回 是否已付费状态
// 3.如果是老用户激活或者已进线的情况，不报错，依然返回正常数据
// 增加是否判断新老用户的参数
export const createOrFindLead = (data: ICreateOrFindLeadReq) => {
  return getTimestamp().then((res) => {
    return request.post<ICreateOrFindLeadRes, ICreateOrFindLeadRes>('/public/lead/goStudent/create', data, {
      signature: true,
      timestamp: res,
    });
  });
};
